import { render } from "./Subtitle.vue?vue&type=template&id=49673c67&scoped=true"
import script from "./Subtitle.vue?vue&type=script&lang=js"
export * from "./Subtitle.vue?vue&type=script&lang=js"

import "./Subtitle.vue?vue&type=style&index=0&id=49673c67&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49673c67"]])

export default __exports__